// broadcasterCommunicationService.ts
import { GameCommunicationService } from '@pp/core/src/services/gameCommunication/GameCommunicationService';
import { NativeWebSocket } from '@pp/core/src/services/webSocket/WebSocketService';

const isProduction = (): boolean => process.env.NODE_ENV === 'production';

export const broadcasterCommunicationService = new GameCommunicationService(NativeWebSocket, !isProduction());
